import { EngineTriggerType } from 'webitel-sdk';

const TriggerTypes = Object.freeze([
  { locale: 'objects.integrations.triggers.cron', value: EngineTriggerType.Cron },
]);

export default TriggerTypes;
